import HGLink from '@/components/links'
import Popup, { PopupWrapClassName } from '@/components/popup'
import { Menus } from '@/entities/menus'
import IconArrowDouble from '@icon/variable/arrow-double.svg'
import { cn } from '@utils'
import NavItem from './item'

export default function More({ data }: { data: Menus[] }) {
  return (
    <>
      <NavItem className='block @header-nav:hidden'>
        <button
          type='button'
          className={cn(
            'cursor-pointer hover:text-white transition-colors group/morebtn',
            PopupWrapClassName
          )}
        >
          More
          <IconArrowDouble className='ml-1 -rotate-90 fill-current group-hover/morebtn:rotate-90' />
          <Popup>
            <ul className='py-2 w-50'>
              {data.splice(3).map((menu) => (
                <Item key={menu.id}>
                  <HGLink
                    href={
                      String(menu.slug).startsWith('/')
                        ? menu.slug
                        : `/${menu.slug}`
                    }
                    aria-label={`go to ${menu.name}`}
                    className='hover:text-primary transition-colors block px-4 py-2'
                    activeClassName='text-primary'
                  >
                    {menu.name}
                  </HGLink>
                </Item>
              ))}
            </ul>
          </Popup>
        </button>
      </NavItem>
    </>
  )
}

function Item({ children }: { children: React.ReactNode }) {
  return (
    <li className='text-font-primary font-medium text-base text-left hover:bg-primary-light/40 hover:text-primary transition-colors'>
      {children}
    </li>
  )
}
